import { render, staticRenderFns } from "./ReferenceBookNomenclature.vue?vue&type=template&id=5ab6e596&"
import script from "./ReferenceBookNomenclature.vue?vue&type=script&lang=js&"
export * from "./ReferenceBookNomenclature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports